import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'partnersFilter', namespaced: true })
export default class PartnersFilter extends FilterModule {
    constructor(module: PartnersFilter) {
        super(module);
    }
}
